import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { facilitySchema } from "@src/appV2/Facilities/types";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { shiftRateNegotiationSchema } from "@src/appV2/OpenShifts/RateNegotiation/types";
import { type UseQueryResult } from "@tanstack/react-query";
import { z } from "zod";

const workerRateNegotiationSchema = z.object({
  _id: z.string(),
  start: z.string(),
  end: z.string(),
  agentReq: z.string(),
  name: z.string(),
  rateNegotiation: shiftRateNegotiationSchema,
  facility: facilitySchema,
});

const workerRateNegotiationResponseSchema = z.array(workerRateNegotiationSchema);
export type WorkerRateNegotiation = z.infer<typeof workerRateNegotiationSchema>;
export type WorkerRateNegotiationResponse = WorkerRateNegotiation[];

export function useWorkerNegotiationShifts(
  options: UseGetQueryOptions<WorkerRateNegotiationResponse> = {}
): UseQueryResult<WorkerRateNegotiationResponse> {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_BASE_API_URL}/negotiation/workerNegotiatingShifts`,
    responseSchema: workerRateNegotiationResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_RATE_NEGOTIATIONS_LIST_FAILURE,
      userErrorMessage: "Error while getting worker negotiation shifts",
    },
    ...options,
  });
}
